/**
 * @desc abolishOms
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.transportToDetailFacadeImpl.abolishOms.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/abolishOms`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
